import { HtmlComponent, ItemType } from '@varo/graphql-schema-types';
import { Maybe } from 'graphql/jsutils/Maybe';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import HTMLComponent from 'shared/components/HTMLRenderer/HTMLComponent/HTMLComponent';
import ContentList from 'shared/components/vxl/ContentList/ContentList';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import TitleSmText from 'shared/components/vxl/typography/primary/title/TitleSmText';
import { UnknownGQLType } from 'shared/legacySDUIAdapters/genericRouteAction';
import theme from 'shared/styles/theme';

interface TermsAndConditionsContentProps {
  upperText?: Maybe<string>;
  bulletsTitle?: Maybe<string>;
  bulletPoints?: Maybe<string[]>;
  lowerText?: Maybe<string>;
  disclosureText?: Maybe<HtmlComponent>;
  navigateForAction: (action: Maybe<UnknownGQLType>) => void;
}

const TermsAndConditionsContent = ({
  upperText,
  bulletsTitle,
  bulletPoints,
  lowerText,
  disclosureText,
  navigateForAction,
}: TermsAndConditionsContentProps) => {
  return (
    <View style={styles.container}>
      {upperText ? <BodyBaseText>{upperText}</BodyBaseText> : null}
      {bulletsTitle ? <TitleSmText>{bulletsTitle}</TitleSmText> : null}
      {bulletPoints ? (
        <ContentList
          itemType={ItemType.Number}
          contentList={bulletPoints.map((point) => (
            <BodyBaseText key={point}>{point}</BodyBaseText>
          ))}
        />
      ) : null}
      {lowerText ? <BodyBaseText>{lowerText}</BodyBaseText> : null}
      {disclosureText ? (
        <HTMLComponent
          {...disclosureText}
          navigateForAction={navigateForAction}
        />
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: theme.spacing.m,
    padding: theme.spacing.m,
  },
});

export default TermsAndConditionsContent;
